import { apiBaseUrl, requestApi } from "./client.js";
import { apiErrorFromResponse, networkError } from "./errors.js";

export interface SignInInput {
  email: string;
  password: string;
}

export interface SignUpInput extends SignInInput {
  name: string;
}

async function authRequest(path: string, body?: unknown): Promise<unknown> {
  let response: Response;
  try {
    const init: RequestInit = {
      credentials: "include",
      method: "POST",
    };
    if (body !== undefined) {
      init.body = JSON.stringify(body);
      init.headers = { "content-type": "application/json" };
    }
    response = await fetch(`${apiBaseUrl}/auth/${path}`, init);
  } catch (error) {
    throw networkError(error);
  }

  const text = await response.text();
  let result: unknown = null;
  if (text) {
    try {
      result = JSON.parse(text);
    } catch {
      result = text;
    }
  }

  if (!response.ok) {
    throw apiErrorFromResponse(response, result);
  }
  return result;
}

export async function signInWithEmail(input: SignInInput): Promise<void> {
  await authRequest("sign-in/email", input);
}

export async function signUpWithEmail(input: SignUpInput): Promise<void> {
  await authRequest("sign-up/email", input);
}

export async function requestPasswordReset(email: string): Promise<void> {
  await authRequest("request-password-reset", { email });
}

export async function signOut(): Promise<void> {
  await authRequest("sign-out");
}

export async function acceptInvitation(token: string): Promise<void> {
  await requestApi("/invitations/accept", {
    body: JSON.stringify({ token }),
    method: "POST",
  });
}

export async function signInWithSocialProvider(
  provider: "apple" | "google",
): Promise<string | null> {
  const result = await authRequest("sign-in/social", { provider });

  if (
    result &&
    typeof result === "object" &&
    "url" in result &&
    typeof result.url === "string"
  ) {
    return result.url;
  }
  return null;
}
